(function($) {

    var repositionMegaDropdown = function(){
        // delay because of transition
        setTimeout(function(){
            if ($('[data-megadropdown-anchor]').length &&
                $('.mainmenu .menu.level0 > li > ul').length &&
                $('[data-megadropdown-anchor]').is(':visible') &&
                $('.mainmenu .menu.level0 > li > ul').is(':visible')) {
                    var newTop = $('[data-megadropdown-anchor]').outerHeight(false) + 3;
                    $('.mainmenu .menu.level0 > li > ul').css({ 'top': newTop });
            }
        }, 350);
    };

	// Custom event watchers
    $(window).on('megadropdown.is-open', function(){
		$('html').addClass('megadropdown-is-open');
    });

    $(window).on('megadropdown.is-closed', function(){
		$('html').removeClass('megadropdown-is-open');
    });

    // Navigation Click Events (open/close)
	$('.top-bar .mainmenu .menu.level0 > li').on('click', function(e){

		// Check if the click was inside a submenu to prevent bubbling
        if ($(e.target).closest('.sub-menu').length) {
            return;
        }

        if($('> .sub-menu', $(this)).length){
			e.preventDefault();
			$('.sub-menu.nav-open').removeClass('nav-open');
			$('.menu-item.sub-menu-open').removeClass('sub-menu-open');
			$('> .sub-menu', $(this)).addClass('nav-open');
			$(this).addClass('sub-menu-open');
			$(window).trigger('megadropdown.is-open');
        }
	});
	$('.menu .close-button').on('click', function(e){
		e.preventDefault();
		const $subMenu = $(this).parents('.sub-menu');
		$subMenu.first().removeClass('nav-open');
		$subMenu.parent().removeClass('sub-menu-open');
		$(window).trigger('megadropdown.is-closed');
	});

	// Set position of megadropdown on page load / resize
    $(window).on('load.dm resize.dm wpplugin.ajax-search/search-open sticky.zf.stuckto:top sticky.zf.unstuckfrom:top', repositionMegaDropdown);

    // Initialize megadropdown overlay
    function initMegadropdownOverlay() {
        if (!$('.megadropdown-overlay').length) {
            $('<div class="megadropdown-overlay"></div>').appendTo('body');
        }
    }

    // Initialize on document ready
    $(document).ready(function() {
        initMegadropdownOverlay();

        // Bind click handler to the overlay
        $(document).on('click', '.megadropdown-overlay', function() {
            $('.sub-menu.nav-open').removeClass('nav-open');
            $(window).trigger('megadropdown.is-closed');
        });
    });

})(jQuery);